import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import moengage from "@moengage/web-sdk";

export function filterSurveyItemsByCategory(surveyItems, categoryType) {
  return surveyItems.filter((item) => item.category === categoryType);
}

export const storeLocalStorage = (itemLabel, itemName) => {
  secureLocalStorage.setItem(itemLabel, itemName);
};

export const getPathPrefix = () => {
  const pathParts = window.location.pathname.split("/");
  const category = pathParts[1];

  if (category === "men") {
    return "/men/";
  } else if (category === "women") {
    return "/women/";
  } else if (category === "over40") {
    return "/over40/";
  } else {
    return "/";
  }
};

export const getPathPrefix2 = () => {
  if (window.location.href === "https://usa.fastbetter.com/") {
    return "usa";
  } else if (window.location.href === "https://uk.fastbetter.com/") {
    return "uk";
  } else if (window.location.href === "https://us.fastbetter.com/") {
    return "us";
  } else if (window.location.href === "https://ca.fastbetter.com/") {
    return "ca";
  } else if (window.location.href === "https://aus.fastbetter.com/") {
    return "aus";
  } else {
    return "us";
  }
};

export const useGoToPage = () => {
  const navigate = useNavigate();
  const goToPage = (itemLabel, itemName, page = "/") => {
    const urlPre = getPathPrefix();
    if (itemLabel) {
      secureLocalStorage.setItem(itemLabel, itemName);
    }
    navigate(urlPre + page);
  };
  return goToPage;
};

export const decrementPrev = ({ setProgressWidth }) => {
  return setProgressWidth((prev) => prev + 1);
};

export const maskEmail = (email) => {
  const atIndex = email.indexOf("@");
  if (atIndex !== -1) {
    const maskedPart = email.substring(0, 2) + "*".repeat(atIndex - 2);
    const maskedEmail = maskedPart + email.substring(atIndex);
    return maskedEmail;
  } else {
    return email; // If there's no "@" symbol, return the original email
  }
};

export const validatePageSavedData = () => {
  const getCurrentPage = (currentUrl) => {
    return allPages.find((page) => page.url === currentUrl);
  };

  const allPages = [
    { page: 1, url: "/", selfData: null, prepageData: null },
    { page: 2, url: "/what_name", selfData: "username", prepageData: null },
    { page: 3, url: "/goal", selfData: "goalItem", prepageData: "username" },
    {
      page: 4,
      url: "/fasting",
      selfData: "fastingItem",
      prepageData: "goalItem",
    },
    {
      page: 5,
      url: "/fasting-about",
      selfData: null,
      prepageData: "fastingItem",
    },
    { page: 6, url: "/activity", selfData: "activityItem", prepageData: null },
    {
      page: 7,
      url: "/nutrition",
      selfData: "nutritionItem",
      prepageData: "activityItem",
    },
    {
      page: 8,
      url: "/meals",
      selfData: "mealItem",
      prepageData: "nutritionItem",
    },
    {
      page: 9,
      url: "/dietary",
      selfData: "dietaryItem",
      prepageData: "mealItem",
    },
    {
      page: 10,
      url: "/allergies",
      selfData: "allergyItem",
      prepageData: "dietaryItem",
    },
    {
      page: 11,
      url: "/dailywater",
      selfData: "waterItem",
      prepageData: "allergyItem",
    },
    {
      page: 12,
      url: "/night",
      selfData: "nightItem",
      prepageData: "waterItem",
    },
    { page: 13, url: "/weightloss", selfData: null, prepageData: "nightItem" },
    { page: 14, url: "/gender", selfData: "gender", prepageData: null },
    { page: 15, url: "/testimonial", selfData: null, prepageData: "gender" },
    { page: 16, url: "/age", selfData: "age", prepageData: "gender" },
    { page: 17, url: "/height", selfData: "height", prepageData: "age" },
    { page: 18, url: "/weight", selfData: "weight", prepageData: "height" },
    {
      page: 19,
      url: "/weightgoal",
      selfData: "weightGoal",
      prepageData: "weight",
    },
    {
      page: 20,
      url: "/motivating",
      selfData: "motivationItem",
      prepageData: "weightGoal",
    },
    {
      page: 21,
      url: "/event",
      selfData: "eventDate",
      prepageData: "motivationItem",
    },
    { page: 22, url: "/needloss", selfData: null, prepageData: "eventDate" },
    { page: 23, url: "/habits", selfData: "habit", prepageData: null },
    { page: 24, url: "/bodytype", selfData: "bodyType", prepageData: "habit" },
    {
      page: 25,
      url: "/eatinghabits",
      selfData: "habitItem",
      prepageData: "bodyType",
    },
    {
      page: 26,
      url: "/emotions",
      selfData: "emotionItem",
      prepageData: "habitItem",
    },
    {
      page: 27,
      url: "/afterweek",
      selfData: "afterWeekItem",
      prepageData: "emotionItem",
    },
    {
      page: 28,
      url: "/peopleround",
      selfData: "peopleRoundItem",
      prepageData: "afterWeekItem",
    },
    {
      page: 29,
      url: "/multitasking",
      selfData: "multiTaskingItem",
      prepageData: "peopleRoundItem",
    },
    {
      page: 30,
      url: "/myplate",
      selfData: "myPlateItem",
      prepageData: "multiTaskingItem",
    },
    {
      page: 31,
      url: "/preliminary",
      selfData: null,
      prepageData: "myPlateItem",
    },
    { page: 32, url: "/realtalk", selfData: null, prepageData: null },
    { page: 33, url: "/journey", selfData: "journeyItem", prepageData: null },
    {
      page: 34,
      url: "/i-like",
      selfData: "ilikeItem",
      prepageData: "journeyItem",
    },
    {
      page: 35,
      url: "/myself",
      selfData: "mySelfItem",
      prepageData: "ilikeItem",
    },
    {
      page: 36,
      url: "/priorities",
      selfData: "prioritiesItem",
      prepageData: "mySelfItem",
    },
    {
      page: 37,
      url: "/gainweight",
      selfData: "gainweightItem",
      prepageData: "prioritiesItem",
    },
    {
      page: 38,
      url: "/diagnosed",
      selfData: "diagnosedItem",
      prepageData: "gainweightItem",
    },
    {
      page: 39,
      url: "/holistic",
      selfData: "holisticItem",
      prepageData: "diagnosedItem",
    },
    { page: 40, url: "/goodhand", selfData: null, prepageData: "holisticItem" },
    { page: 41, url: "/email", selfData: "email", prepageData: null },
    { page: 42, url: "/priceplan", selfData: null, prepageData: "finalData" },
    {
      page: 43,
      url: "/callback/pg/:getTranId",
      selfData: null,
      prepageData: null,
    },
    { page: 44, url: "/user-registration", selfData: null, prepageData: null },
    { page: 45, url: "/thank-you", selfData: null, prepageData: null },
  ];

  const currentUrl = window.location.pathname;
  const currentPage = getCurrentPage(currentUrl);
  if (
    currentPage?.prepageData !== null &&
    !secureLocalStorage.getItem(currentPage?.prepageData)
  ) {
    // console.log(secureLocalStorage.getItem(currentPage?.prepageData));
    return false;
  } else {
    return true;
  }
};

// Google analytic for data layer
export const DataLayer = ({
  event,
  stage,
  currency = null,
  value = null,
  transaction_id = null,
}) => {
  if (window.dataLayer) {
    let currentTime = new Date().toISOString();
    let siteUrl = window.location.href;
    if (currency && value && transaction_id) {
      window.dataLayer.push({
        event: event,
        stage: stage,
        currentTime: currentTime,
        siteUrl: siteUrl,
        currency: currency,
        value: value,
        transaction_id: transaction_id,
      });
    } else {
      window.dataLayer.push({
        event: event,
        stage: stage,
        currentTime: currentTime,
        siteUrl: siteUrl,
      });
    }

    // console.log(window.dataLayer);
    // console.log(event);
  }
};

export const MoEngageInitialization = () => {
  // 32IDOHIC6T5MUQWXILK1LZGE // avv
  // 51HVDLTQXTXO6YQBRTL6GQP6 // Fastbetter
  // WNKJQLJY3M1MN7KOM9S17SWP // Ketobalanced
  moengage.initialize({
    app_id: "51HVDLTQXTXO6YQBRTL6GQP6",
    debug_logs: 0,
  });

  moengage.add_unique_user_id("fbtest_id1@yopmail.com");
  moengage.add_email("fbtest@yopmail.com");

  // moengage.track_event("Add to Cart", { name: "Phone", price: "100000" });
  console.log(122);
};
